// Priceupdatemanager.actions.ts
import { DropdownOption } from 'material-react-table';
import { LabelValue } from '../../Types/filter.types';
import axiosInstance from '../../Utils/axiosInstance';
import {
  PriceUpdateFilters,
  PriceUpdateListResponse,
  UpdateTasPriceResultItem,
  ManualPricePayload,
  ManualPriceUpdateResponse,
  TasUpdateResponse,
  FuturesContract,
  TasAuditReportResponse,
} from './Priceupdatemanager.types';

const LIST_URL = '/paper-app/update-marker-TAS-trades/';

export interface FetchTradesArgs {
  filters: PriceUpdateFilters;
  useBaseline?: boolean;
}

const buildParams = (filters: PriceUpdateFilters): URLSearchParams => {
  const params = new URLSearchParams();

  if (filters.datePreset === 'Custom') {
    if (filters.fromDate) params.append('from_date', filters.fromDate);
    if (filters.toDate) params.append('to_date', filters.toDate);
  } else {
    if (filters.fromDate && filters.toDate && filters.fromDate !== filters.toDate) {
      params.append('from_date', filters.fromDate);
      params.append('to_date', filters.toDate);
    } else if (filters.fromDate) {
      params.append('date', filters.fromDate);
    }
  }

  if (filters.pricingMechanism.length) {
    params.append('marker_tas_type', filters.pricingMechanism.join(','));
  }
  if (filters.priceUpdateStatus.length) {
    params.append('price_update_status', filters.priceUpdateStatus.join(','));
  }
  if (filters.symbolCode.trim()) {
    params.append('symbol_code', filters.symbolCode.trim());
  }
  if (filters.tradeId.trim()) {
    params.append('trade_id', filters.tradeId.trim());
  }
  if (filters.commodity.length) {
    params.append('commodity', filters.commodity.join(','));
  }
  if (filters.book.length) {
    params.append('book', filters.book.join(','));
  }

  return params;
};

export const fetchPriceUpdateTrades = async (
  args: FetchTradesArgs,
): Promise<PriceUpdateListResponse> => {
  if (args.useBaseline) {
    const { data } = await axiosInstance.get<PriceUpdateListResponse>(LIST_URL);
    return data;
  }

  const params = buildParams(args.filters);
  const { data } = await axiosInstance.get<PriceUpdateListResponse>(LIST_URL, { params });
  return data;
};

const TAS_UPDATE_URL = '/paper-app/update-TAS-trades/';

export const updateTasPrice = async (): Promise<TasUpdateResponse> => {
  const { data } = await axiosInstance.get<TasUpdateResponse>(TAS_UPDATE_URL);
  return data;
};

export const updateManualPrice = async (
  payload: ManualPricePayload | ManualPricePayload[],
): Promise<ManualPriceUpdateResponse> => {
  const { data } = await axiosInstance.post<ManualPriceUpdateResponse>(
    '/paper-app/update-marker-TAS-price_manual/',
    payload,
  );
  return data;
};

const PRICING_MECHANISM_DROPDOWN_URL = '/paper-app/TAS-MM-dropdown/';

export const fetchPricingMechanismOptions = async (): Promise<LabelValue[]> => {
  const { data } = await axiosInstance.get<LabelValue[]>(PRICING_MECHANISM_DROPDOWN_URL);
  return data;
}

const FUTURES_CONTRACT_NAMES_URL = '/paper-app/futures-contract-names/';

export const fetchCommodityOptions = async (): Promise<LabelValue[]> => {
  const { data } = await axiosInstance.get<FuturesContract[]>(FUTURES_CONTRACT_NAMES_URL);
  return data.map((item) => ({
    value: item.id,
    label: item.contract_name,
  }));
};

const TAS_AUDIT_REPORT_URL = '/paper-app/tas-audit-report/';

export const fetchTasAuditReport = async (): Promise<TasAuditReportResponse> => {
  const { data } = await axiosInstance.get<TasAuditReportResponse>(TAS_AUDIT_REPORT_URL);
  return data;
};

export const primaryActionButtonSx = {
  height: { xs: '36px', sm: '32px' },
  flex: { sm: '0 0 auto' },
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.75rem',
  borderRadius: '8px',
  backgroundColor: '#585bcc',
  color: '#fff !important',
  boxShadow: 1,
  paddingLeft: '20px !important',
  paddingRight: '20px !important',
  minWidth: 'unset',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    backgroundColor: 'primary.dark',
    boxShadow: 2,
  },
  '&.Mui-disabled': {
    backgroundColor: 'action.disabledBackground',
    color: 'action.disabled',
  },
} as const;